import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../services/api';
import type { StorageFile } from './useStorageListing';

export type ForensicImageType = 'cellebrite' | 'oxygen' | 'axiom' | 'paraben';

export interface IioListing {
  type: string;
  files: StorageFile[];
}

export function useIioListing(
  projectId: string,
  baseDir: string,
  enabled: boolean,
  forensicImageType?: ForensicImageType | null,
) {
  return useQuery<IioListing>({
    queryKey: ['iio-listing', projectId, baseDir, forensicImageType ?? null],
    queryFn: async () => {
      const data = await api.post<{ type: string; files: any[] }>(
        `/project/${projectId}/sftp`,
        { baseDir, forensicImageType: forensicImageType ?? null },
      );
      return {
        type: data?.type ?? '',
        files: (data?.files ?? []).map(f => ({
          name: f.file ?? f.relativePath ?? '',
          path: f.relativePath ?? '',
          isDirectory: Boolean(f.isDirectory),
          size: f.bytes,
        })),
      };
    },
    enabled: !!projectId && enabled,
    retry: false,
    staleTime: 0,
  });
}
